import { useMemo } from "react";
import { DEFAULT_LANGUAGE_CODE } from "@nf/constants";
import { useRouter } from "next/router";

export const useLanguage = () => {
  const router = useRouter();
  const { language: languageQuery } = router.query;

  const language: string = useMemo(() => {
    if (languageQuery) {
      return languageQuery as string;
    }

    return DEFAULT_LANGUAGE_CODE;
  }, [languageQuery]);

  return language;
};
